import { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons

function AutoLogout() {
   const SOCKETURL = process.env.REACT_APP_BASEURL_SOCKETURL;
  const [socketCon, setSocketCon] = useState(null);
  const [Password, setPassword] = useState("");
  const [email, setEmail] = useState(""); // State for email input
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate(); // Navigation hook to navigate back to login

  // Initialize socket connection
  // useEffect(() => {
  //   const socket = io(SOCKETURL); // Use the socket URL from env
  //   setSocketCon(socket);

  //   socket.on("connect", () => {
  //     console.log("Connected to WebSocket server");
  //   });

  //    // USER A RECEIVES LOGOUT REQUEST
  //   socket.on("receive_logout_request", (data) => {
  //     const { requestedBy } = data;

  //     const confirmLogout = window.confirm(
  //       `${requestedBy} is requesting you to logout. Do you accept?`
  //     );

  //     socket.emit("logout_request_response", {
  //       requestedBy,
  //       accepted: confirmLogout,
  //     });
  //   });

  //   // FORCE LOGOUT EVENT
  //   socket.on("force_logout", () => {
  //     alert("Your session has been logged out by another login request.");
  //     socket.disconnect();
  //     navigate("/");
  //   });

  //   // Cleanup socket connection on component unmount
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [SOCKETURL]);

    useEffect(() => {
    // reuse socket from login if available
    const existing = window.__socket;
    const socket = existing || io(SOCKETURL);

    // if we created it here, persist it so other pages reuse
    if (!existing) window.__socket = socket;

    setSocketCon(socket);

    const storedEmail = (window.sessionStorage.getItem("user-email") || "").toLowerCase();

    socket.on("connect", () => {
      console.log("Connected to WebSocket server, id:", socket.id);
      // If we have logged-in email (stored during login), inform server
      if (storedEmail) {
        socket.emit("user_connected", { email: storedEmail });
        console.log("Emitted user_connected from AutoLogout for", storedEmail);
      }
    });

    // receive logout request (USER A)
    const handleReceiveLogout = (data) => {
      const requestedBy = (data.requestedBy || "").toLowerCase();
      const requesterId = data.requesterId; // server will provide this
      const confirmLogout = window.confirm(`${requestedBy} is requesting you to logout. Do you accept?`);
      socket.emit("logout_request_response", {
        requestedBy,      // the requester's email
        requesterId,      // original requester socket id so server can route back
        accepted: confirmLogout,
      });
    };
    socket.on("receive_logout_request", handleReceiveLogout);

    // final forced logout
    const handleForceLogout = () => {
      alert("Your session has been logged out by another login request.");
      // mark as disconnected on client and navigate to login
      try { socket.disconnect(); } catch (e) {}
      navigate("/");
    };
    socket.on("force_logout", handleForceLogout);

    // feedback for the requester (USER B)
    const handleLogoutRequestStatus = (payload) => {
      // payload: { statusCode, message }
      console.log("logout_request_status:", payload);
      if (payload && payload.message) alert(payload.message);
    };
    socket.on("logout_request_status", handleLogoutRequestStatus);

    // disconnect confirmation for manual unlock
    const handleDisconnectConfirmation = (data) => {
      const { statusCode, message } = data || {};
      if (statusCode === 1 && message === "USER DISCONNECTED") {
        alert("You have been successfully disconnected.");
        try { socket.disconnect(); } catch (e) {}
        navigate("/");
      } else if (statusCode === 1 && message === "INVALID EMAIL OR PASSWORD") {
        alert("Invalid email or password. Please try again.");
      } else if (statusCode === 0 && message === "INTERNAL SERVER ERROR") {
        alert("An internal server error occurred. Please try again later.");
      }
    };
    socket.on("disconnect_confirmation", handleDisconnectConfirmation);

    // cleanup listeners on unmount (do not always disconnect if socket reused)
    return () => {
      socket.off("receive_logout_request", handleReceiveLogout);
      socket.off("force_logout", handleForceLogout);
      socket.off("logout_request_status", handleLogoutRequestStatus);
      socket.off("disconnect_confirmation", handleDisconnectConfirmation);

      // if we created the socket here (no existing), disconnect it
      if (!existing) {
        try { socket.disconnect(); } catch (e) {}
        window.__socket = null;
      } else {
        // if reused, keep it connected but clear local state
      }
      setSocketCon(null);
    };
  }, [SOCKETURL, navigate]);

  // USER B sends logout request
  const handleLogoutRequest = () => {
    if (!email) { alert("Please enter email"); return; }
    if (!Password) { alert("Please enter password"); return; }
    if (!socketCon) { alert("Socket not connected"); return; }

 // Use lowercase normalization
  const targetEmail = email.toLowerCase();        // the account you want logged out
  const requesterEmail = (email.toLowerCase()); 

    // normalize email to lowercase
    socketCon.emit("logout_request", {
      EMAIL: email.toLowerCase(),
      REQUESTED_BY: requesterEmail,
      PASSWORD: Password,
    });
    // response handled through logout_request_status listener
  };


  // Emit user_disconnected event when user disconnects
  // Emit user_disconnected event and handle confirmation

   // USER B SENDS LOGOUT REQUEST
  // const handleLogoutRequest = () => {
  //   if (!email) {
  //     alert("Please enter email");
  //     return;
  //   }

  //   if (!Password) {
  //     alert("Please enter password");
  //     return;
  //   }

  //   if (socketCon) {
  //     socketCon.emit("logout_request", {
  //       EMAIL: email,
  //       PASSWORD: Password,
  //     });

  //       socketCon.on("logout_request_status", (data) => {
  //       const { statusCode, message } = data;

  //         console.log(statusCode)
  //       if (statusCode === 1) {
  //         alert(message);
  //       } else {
  //         alert("Request failed");
  //       }
  //     });
  //   }
  // };

// EMERGENCY FORCE LOGOUT (ADMIN / USER B)
const handleUserDisconnected = () => {
  if (!email) {
    alert("Please enter your email");
    return;
  }

  if (!Password) {
    alert("Please enter your password");
    return;
  }

  if (!socketCon) {
    alert("Socket not connected");
    return;
  }

  socketCon.emit("user_unlock", {
    EMAIL: email.toLowerCase(),
    PASSWORD: Password,
    FORCE: true // <-- important
  });
};


  // const handleUserDisconnected = () => {
  //   if (!email) {
  //     alert("Please enter your email");
  //     return;
  //   }
  //   if (!Password) {
  //     alert("Please enter your password");
  //     return;
  //   }

  //   if (socketCon) {
  //     const userData = { EMAIL: email, PASSWORD: Password };
  //     socketCon.emit("user_unlock", userData);

  //     // Listen for disconnect confirmation
  //     socketCon.on("disconnect_confirmation", (data) => {
  //       const { statusCode, message } = data;

  //       if (statusCode === 1) {
  //         if (message === "USER DISCONNECTED") {
  //           alert("You have been successfully disconnected.");
  //           socketCon.disconnect(); // Close the socket connection
  //           navigate("/"); // Navigate back to login after disconnection
  //         } else if (message === "INVALID EMAIL OR PASSWORD") {
  //           alert("Invalid email or password. Please try again.");
  //         }
  //       } else if (statusCode === 0 && message === "INTERNAL SERVER ERROR") {
  //         alert("An internal server error occurred. Please try again later.");
  //       }
  //     });
  //   }
  // };

  const handleBackToLogin = () => {
    navigate("/"); // Adjust this path based on your route
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Navbar */}
      <nav className="bg-gray-800 p-4 shadow-lg">
        <div className="container mx-auto flex items-center justify-between">
          <h1 className="text-white text-xl font-bold">Tech23</h1>

          <button
            onClick={handleBackToLogin}
            className=" font-semibold bg-white px-4 py-2 rounded-md"
          >
            Back to Login
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="flex flex-col items-center justify-center min-h-[80vh]">
        <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
          {/* <h2 className="text-2xl font-semibold mb-4 text-center">
            Disconnect Session
          </h2> */}

           <h2 className="text-2xl font-semibold mb-4 text-center">
            Logout Request
          </h2>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Enter Your Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter your email"
              required
            />

            <label className="block text-sm font-medium text-gray-700 mb-2">
              Enter Your Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"} // Toggle input type
                value={Password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter your password"
                required
              />
              {/* Eye Icon */}
              <span
                className="absolute inset-y-0 right-4 flex items-center cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="flex gap-2">

          <button
            onClick={handleUserDisconnected}
            className="w-64 bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
            Force Disconnect
          </button>

              <button
            onClick={handleLogoutRequest}
            className="w-64 bg-indigo-600 text-white py-2 px-4 rounded-md"
            >
            Send Logout Request
          </button>
            </div>

        </div>
      </div>
    </div>
  );
}

export default AutoLogout;
